import React from 'react';
import { Form } from 'react-bootstrap';
import { MailTemplateType } from 'helper/mailer';
import Selector from 'components/DesignSystem/Selector';

export default function ProductSelect({
  types,
  typeId,
  setTypeId,
  setSubtypeId,
  isValid,
}: {
  types: MailTemplateType[] | undefined,
  typeId: number,
  setTypeId: (value: React.SetStateAction<number>) => void,
  setSubtypeId: (value: React.SetStateAction<number>) => void,
  isValid: boolean,
}) {
  if (!types) {
    return (
      <Form.Select className="rounded-0" disabled>
        <option>Carregando...</option>
      </Form.Select>
    );
  }

  const handleChange = (value: React.SetStateAction<number>) => {
    setTypeId(value);
    setSubtypeId(-1);
  };

  return (
    <Selector
      id="product-select"
      label="Produto"
      value={typeId}
      setValue={handleChange}
      error={isValid && !typeId ? 'Selecione um produto' : undefined}
    >
      {types.map((type) => (
        <option key={type.id} value={type.id}>{type.label}</option>
      ))}
    </Selector>
  );
}
